import React, { useState } from "react";
import Logo from "./navbar/logo";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { getSignUpLink, getSignInLink } from "../../utils/path-helper";
import "./navbar/btns-group.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from "@fortawesome/free-solid-svg-icons";

const SSHeader = ({ isLogoDisabled }) => {
  const navigate = useNavigate();
  const { locale } = useParams();
  let signInLink = getSignInLink(locale, "");
  let signUpLink = getSignUpLink(locale, "");

  const { t } = useTranslation();

  const onClickSignIn = () => {
    navigate(signInLink);
  };
  const onClickSignUp = () => {
    navigate(signUpLink);
  };

  const [isHelpGuideVisible, setIsHelpGuideVisible] = useState(false);

  const toggleHelpGuide = () => {
    setIsHelpGuideVisible(!isHelpGuideVisible);
  };

  return (
    <>
      <header className="header py-2 border-b border-[#DBDEE1]">
        <nav className="mx-auto px-4 md:mx-4 lg:mx-36">
          <div className="flex justify-between items-center">
            <div>
              <Logo disabled={isLogoDisabled} />
            </div>
            <div id="navbarNavAltMarkup">
              <div className="flex items-center">
                <Link
                  to="/help-guide/"
                  target="_blank"
                  className="text-base rounded-full bg-[#0E76FF] hover:bg-[#0756c7] text-white font-semibold py-3 px-5 transition"
                  onClick={onClickSignUp}
                >
                  HELP GUIDE
                </Link>
                {/* <button className="md:hidden text-gray-400 text-2xl" onClick={toggleHelpGuide}>
                  <FontAwesomeIcon icon={faBars} />
                </button> */}
              </div>
            </div>
          </div>
          <div
            className={`w-full mt-4 md:hidden transition-all duration-1000 ease-in-out ${
              isHelpGuideVisible ? "max-h-20 opacity-100" : "max-h-0 opacity-0"
            }`}
          >
            <button
              className="text-base border rounded border-[#fdce43] hover:border-[#424a5b] bg-[#fdce43] hover:bg-[#424a5b] text-[#424a5b] hover:text-white font-medium py-3 px-4 w-full text-center"
              //   onClick={onClickSignUp}
            >
              HELP GUIDE
            </button>
          </div>
        </nav>
      </header>
    </>
  );
};

export default SSHeader;
